import React, { useCallback, useEffect, useRef, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { EstadoTag, fechaHora, poli } from './poliApi';
import DetallePrueba from './DetallePrueba';

/**
 * P-4 Bandeja de asignacion del Administrador de poligrafias: solicitudes nuevas (1), pedidos de
 * reprogramacion (3) e inasistencias dentro del plazo de 14 dias (9). La fecha se asigna en el
 * detalle de cada prueba.
 */
const GRUPOS = [
    { estado: 1, titulo: 'Solicitudes nuevas' },
    { estado: 3, titulo: 'Piden reprogramacion' },
    { estado: 9, titulo: 'No asistieron (plazo para reagendar)' }
];

const PoliAsignacion = () => {
    const toast = useRef(null);
    const [cfg, setCfg] = useState(null);
    const [filas, setFilas] = useState([]);
    const [detalle, setDetalle] = useState(null);
    const [cargando, setCargando] = useState(false);

    const cargar = useCallback(async () => {
        setCargando(true);
        try {
            const [c, p] = await Promise.all([poli('/config'), poli('/asignacion/pendientes')]);
            setCfg(c);
            setFilas(p);
        } catch (e) {
            toast.current && toast.current.show({ severity: 'error', summary: 'Error', detail: e.message, life: 4000 });
        } finally {
            setCargando(false);
        }
    }, []);

    useEffect(() => { cargar(); }, [cargar]);

    return (
        <div className="grid">
            <Toast ref={toast} />
            <div className="col-12 flex align-items-center justify-content-between flex-wrap gap-2">
                <h4 className="m-0">Asignacion de fechas</h4>
                <Button label="Actualizar" icon="pi pi-refresh" className="p-button-outlined" onClick={cargar} loading={cargando} />
            </div>
            {GRUPOS.map((g) => {
                const lista = filas.filter((f) => f.estado === g.estado);
                return (
                    <div key={g.estado} className="col-12">
                        <div className="card mb-0">
                            <h5>{g.titulo} <span className="text-600">({lista.length})</span></h5>
                            <DataTable value={lista} size="small" rowHover dataKey="prueba_id" onRowClick={(e) => setDetalle(e.data.prueba_id)}
                                style={{ cursor: 'pointer' }} emptyMessage="Nada pendiente" responsiveLayout="scroll">
                                <Column header="Colaborador" body={(r) => <div><b>{r.apellidos} {r.nombres}</b><br /><small className="text-600">{r.cedula}</small></div>} />
                                <Column header="Compania" body={(r) => <div>{r.compania}<br /><small className="text-600">{r.proyecto}</small></div>} />
                                <Column header="Solicitud" body={(r) => <div>{r.solicitud}<br /><small className="text-600">{r.nombre_grupo}</small></div>} />
                                <Column header="Desde" body={(r) => fechaHora(r.fecha_estado)} />
                                {g.estado === 9 && <Column header="Reagendar hasta" body={(r) => (r.plazo_reagendar ? new Date(r.plazo_reagendar + 'T12:00').toLocaleDateString('es-EC') : '')} />}
                                <Column header="Estado" body={(r) => <EstadoTag fila={r} />} />
                            </DataTable>
                        </div>
                    </div>
                );
            })}
            <DetallePrueba pruebaId={detalle} cfg={cfg} alCerrar={() => setDetalle(null)} alCambiar={() => cargar()} />
        </div>
    );
};

export default PoliAsignacion;
